import React from 'react'

import { Table, Col, Row, Form, Divider } from '_zari/core'

import { IdGen } from 'utils'

const ValesSection = ({ sectionData }) => {
  return (
    <>
      <Row>
        <Col md={3}>
          <Form.Group>
            <Form.Label text='TOTAL' htmlFor='input-vales-total' md={5} alignRightAt='md' />
            <Col md={7}>
              <Form.InputText id='input-vales-total' name='input-vales-total' placeholder={sectionData.total || '--'} disabled />
            </Col>
          </Form.Group>
        </Col>
      </Row>
      <Divider />
      <Table
        headRows={[
          { label: 'LADO' },
          { label: 'SERIE' },
          { label: 'NUMERO' },
          { label: 'COMBUSTIBLE' },
          { label: 'CANTIDAD' },
          { label: 'MONTO' },
          { label: 'FORMA DE PAGO' }
        ]}
        filas={sectionData.movimientos || []}
        maxRowsShown={10}
        rowTemplate={row => (
          <Table.Row key={IdGen.newId()}>
            <Table.Cell>{row.ladoIsla || '--'}</Table.Cell>
            <Table.Cell>{row.serieDocumento || '--'}</Table.Cell>
            <Table.Cell>{row.numeroDocumento || '--'}</Table.Cell>
            <Table.Cell>{row.nombreProducto || '--'}</Table.Cell>
            <Table.Cell>{row.cantidad || '--'}</Table.Cell>
            <Table.Cell>{row.monto || '--'}</Table.Cell>
            <Table.Cell>{row.formaPago || '--'}</Table.Cell>
          </Table.Row>
        )}
      />
    </>
  )
}

export default React.memo(ValesSection)
